import { Trans, useLingui } from "@lingui/react/macro";
import { Alert } from "@offstreetparking/design-system/feedback";
import { formatRuleMessageValues } from "@offstreetparking/design-system/formatters";
import { getRuleErrorDescriptor } from "@offstreetparking/domain/entities/rule/rule-messages";
import type { TRPCClientErrorLike } from "@trpc/client";
import { buildSupportUrl } from "../../../utils/support-url";

type FormErrorAlertProps = {
	serverError?: TRPCClientErrorLike<any> | null | undefined;
	timezone?: string | null;
};

export const FormErrorAlert = ({ serverError, timezone }: FormErrorAlertProps) => {
	const { i18n, t } = useLingui();
	const referenceId = serverError?.data?.referenceId;
	const supportUrl = buildSupportUrl();
	if (!serverError) {
		return null;
	}
	if (serverError.data?.code === 400) {
		if (serverError.data?.rule && serverError.data?.errorTypeI18n) {
			const descriptor = getRuleErrorDescriptor(serverError.data.rule, serverError.data.errorTypeI18n);
			const values = formatRuleMessageValues({
				context: serverError.data.context,
				i18n,
				locale: i18n.locale,
				timezone,
			});
			return (
				<Alert
					type={"error"}
					title={
						descriptor
							? i18n._(descriptor.id, values, { message: descriptor.message })
							: t`Unable to complete this form`
					}
				/>
			);
		}
		return null;
	}
	return (
		<Alert
			type={"error"}
			title={t`Unable to process request`}
			referenceId={referenceId}
			message={
				<Trans>
					Please refresh and retry. If the issue persists, please{" "}
					<a
						className="text-neutral-faded underline"
						href={supportUrl}
						target="_blank"
						rel="noopener noreferrer"
					>
						contact us
					</a>
					.
				</Trans>
			}
		/>
	);
};
